import { render, staticRenderFns } from "./dictionariesForm.vue?vue&type=template&id=5ac0122d&scoped=true&"
import script from "./dictionariesForm.vue?vue&type=script&lang=js&"
export * from "./dictionariesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0122d",
  null
  
)

export default component.exports